let viewportHeight = '100dvh';
const viewport = window.visualViewport;
if (window.visualViewport) {
  viewport.addEventListener('resize', setViewportHeightCss);
  setViewportHeightCss();
}

function setViewportHeightCss() {
  viewportHeight = viewport.height + 'px';
  document.documentElement.style.setProperty('--viewport-height', `${viewportHeight}`);
}

export {setViewportHeightCss, viewportHeight};
